// <preorder-countdown> — recomputes the pre-order "Ships in X–Y days" text against
// the shopper's own today.
//
// snippets/preorder-ship-window.liquid already renders the text server-side, but
// Shopify caches storefront HTML, so that count can be a day or more stale. A custom
// element (rather than a DOMContentLoaded sweep) also covers the cart drawer and cart
// page, which swap their HTML in via the Section Rendering API: connectedCallback runs
// for every freshly inserted notice.
//
// Both dates are read as UTC midnights so the difference is always a whole number of
// days, whatever the viewer's DST rules. Loaded site-wide from layout/theme.liquid
// when pre-order is enabled.
if (!customElements.get('preorder-countdown')) {
  const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;
  const DAY_MS = 86400000;

  const toUtcMs = (iso) => {
    const match = ISO_DATE.exec(iso || '');
    return match ? Date.UTC(+match[1], +match[2] - 1, +match[3]) : null;
  };

  const localIsoDate = (date = new Date()) => {
    const pad = (n) => String(n).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
  };

  customElements.define(
    'preorder-countdown',
    class PreorderCountdown extends HTMLElement {
      connectedCallback() {
        const text = this.shipWindowText();
        if (text && this.textContent !== text) this.textContent = text;
      }

      shipWindowText() {
        const { arrival, window: windowDays, range, within, fallback } = this.dataset;
        const arrivalMs = toUtcMs(arrival);
        const todayMs = toUtcMs(localIsoDate());
        if (arrivalMs === null || todayMs === null) return fallback;

        // Past the arrival date: stock is late, so promise nothing.
        const min = Math.round((arrivalMs - todayMs) / DAY_MS);
        if (min < 0) return fallback;

        const template = min === 0 ? within : range;
        return template.replace('__MIN__', min).replace('__MAX__', min + Number(windowDays));
      }
    }
  );
}
